import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'unh-courses-not-found',
  templateUrl: './courses-not-found.component.html',
  styleUrls: ['./courses-not-found.component.scss'],
})
export class CoursesNotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
